<template>
    <v-container fluid>
        <v-row>
            <v-flex xs3>
                <v-dialog
                    ref="dueDialog"
                    v-model="dueDateDialog"
                    :return-value.sync="routePlanningObject.dateRange"
                    persistent
                    width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class="ma-3"
                            outlined
                            v-model="dateRangeText"
                            label="Date Range"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="routePlanningObject.dateRange" range scrollable color="primary">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="dueDateDialog = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.dueDialog.save(routePlanningObject.dateRange)">OK</v-btn>
                    </v-date-picker>
                </v-dialog>
            </v-flex>
            <v-flex xs3>
                <v-text-field type="number" class="ma-3" label="Minimum Tasks" outlined v-model="routePlanningObject.minimumJobTasks"></v-text-field>
            </v-flex>
            <v-flex xs3>
                <v-text-field type="number" class="ma-3" label="Maximum Tasks" outlined v-model="routePlanningObject.maximumComplexity"></v-text-field>
            </v-flex>
            <v-flex xs3>
                <v-text-field type="number" class="ma-3" label="Radius (Meters)" outlined v-model="routePlanningObject.clusterRadiusMeters"></v-text-field>
            </v-flex>
        </v-row>
        <v-row>
            <v-flex xs3></v-flex>
            <v-flex xs3>
                <v-checkbox class="ma-3" label="Group By City" v-model="routePlanningObject.isGroupedByCity"></v-checkbox>
            </v-flex>
            <v-flex xs3>
                <v-checkbox class="ma-3"  label="Map Boundary Only" v-model="routePlanningObject.isConstrained"></v-checkbox>
            </v-flex>
            <v-flex v-if="disabled === false" xs3 class="text-right">
                <v-btn class="ma-1" @click="preview" outlined color="primary">Preview Plan</v-btn>
                <v-btn class="ma-1" @click="initiateSave" color="primary">Save Plan</v-btn>
            </v-flex>
            <v-flex v-else xs3 class="text-right">
                Saving<br />
                <v-progress-circular
                    indeterminate
                    color="success"
                    v-if="disabled"
                ></v-progress-circular>
            </v-flex>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'
    export default {
        name: 'route-builder-filters',
        props: {
            setBounds: {
                type: Function,
                required: true
            }
        },
        data() {
            return {
                dueDateDialog: false,
                disabled: false,
                selectedDueDate: "",
                routePlanningObject: {
                    dateRange: [],
                    isGroupedByCity: true,
                    isConstrained: false,
                    topLeft: {
                        latitude: 0,
                        longitude: 0
                    },
                    bottomRight: {
                        latitude: 0,
                        longitude: 0
                    },
                    // Minimum job tasks should default to 1
                    minimumJobTasks: 1,
                    // Minimum job tasks should default to 5
                    maximumComplexity: 5,
                    // Radius should default to 5,000
                    clusterRadiusMeters: 5000
                }
            }
        },
        watch: {
            bounds(newValue) {
                this.routePlanningObject.topLeft.latitude = newValue.getNorthWest().lat
                this.routePlanningObject.topLeft.longitude = newValue.getNorthWest().lng
                this.routePlanningObject.bottomRight.latitude = newValue.getSouthEast().lat
                this.routePlanningObject.bottomRight.longitude = newValue.getSouthEast().lng
            }
        },
        computed: {
            ...mapGetters({
                bounds: 'planning/bounds',
                error: 'planning/error'
            }),
            dateRangeText() {
                return this.routePlanningObject.dateRange.join(" — ");
            }
        },
        methods: {
            ...mapActions({
                initiatePreview: 'planning/initiatePreview',
                savePlannedRoutes: 'planning/initiateSave'
            }),
            async preview() {
                this.disabled = true
                if (this.routePlanningObject.isConstrained === true) {
                    await this.setBounds()
                }
                await this.initiatePreview(this.routePlanningObject)
                this.disabled = false
            },
            async initiateSave() {
                this.disabled = true
                if (this.routePlanningObject.isConstrained === true) {
                    await this.setBounds()
                }
                await this.savePlannedRoutes(this.routePlanningObject)
                await this.$router.push('/management/routes/active')
                this.disabled = false
            }
        }
    }
</script>
<style>
    .display-flex {
        display:flex
    }
</style>
